<template>
    <div :class="buttonsClass">
        <slot></slot>
    </div>
</template>

<script>
    export default {
        props: {
            align: { type: String, default: 'center' },
            isDisabled: { type: Boolean, default: false },
        },

        computed: {
            buttonsClass() {
                return {
                    buttons: true,
                    [`buttons--align-${this.align}`]: this.align,
                    'buttons--is-disabbled': this.isDisabled,
                }
            },
        },
    }
</script>
